import Vue from "vue";

const state = {
    packages: [],
    generatingQueue: []
}

const getters = {
    packages: state => {
        return state.packages
    },
    getGeneratingQueue: state => {
        return state.generatingQueue
    }
}

const mutations = {
    setPackagesList (state, data) {
        Vue.set(state, 'packages', data);
    },
    addPackageToQueue (state, data) {
        state.generatingQueue.push(data);
    },
    removePackageFromQueue (state, data) {
        let i = state.generatingQueue.indexOf(data);
        if (i !== -1) {
            state.generatingQueue.splice(i, 1);
        }
    }
}


export default {
    state,
    getters,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/invoices.js